export default __webpack_public_path__ + "static/media/feather.a2603f60.woff";